import { RootState, useAppSelector } from '..';

export const selectClaimBusiness = (state: RootState) => state.claimBusiness;
export const useClaimBusiness = () => useAppSelector(selectClaimBusiness);
